import React from "react";
import { connect } from "react-redux";

import Alert from "components/Common/Alert";

import Icon from "components/Icons/Icon";

import { withT } from "services/translation/";

import { Button } from "react-bootstrap";

import { devMode } from "services/redux/selectors/";

import { getPathRootFromRoute } from "services/redux/selectors/app/";
import { getGroupFromRoute } from "services/redux/selectors/groups";
import { getEnterpriseFromRoute } from "services/redux/selectors/enterprises";
import { loadSingleSiteUsersStart } from "services/redux/actions/singleSites";

import {
  requestUserManagementRemoveStart,
  requestUserManagementRemoveNotified,
  loadUserManagementUserListStart
} from "services/redux/actions";
import {
  singleSiteUserRemoveStart,
  singleSiteUserRemoveNotified,
} from "services/redux/actions/singleSites";

class Remove extends React.Component {
  render() {
    const {
      pathRoot,
      origin,
      group,
      enterprise,
      users,
      disabled,
      user,
      loggedInUser,
      siteName,
      t
    } = this.props;

    const group_id = (group && group.id) || (enterprise && enterprise.root_group_id);

    const groupName = (group && group.name) || (enterprise && enterprise.name);

    const user_id = user.id;
    const userEmail = user.email;

    const selectedUserId = users.actions.removeAccess.user_id;

    if (user_id === selectedUserId) {
      const { success, error } = users.actions.removeAccess;

      if (success) {
        // Refresh
        if (origin === "Companies") {
          this.props.dispatch(
            loadSingleSiteUsersStart({
              originType: "company",
              originId: this.props.companyId,
              sudo_site_id: this.props.sudoSiteId,
            })
          );
        } else if (origin === "SiteView") {
          const params = {
            sudo_site_id: this.props.sudoSiteId,
          }
          if (pathRoot === "enterprise") {
            params["originType"] = "enterprise";
            params["originId"] = enterprise.id;
          }
          this.props.dispatch(
            loadSingleSiteUsersStart(params)
          );
        } else {
          this.props.dispatch(
            loadUserManagementUserListStart({
              group_id,
              enterprise_id: enterprise.id
            })
          )
        };
        Alert({
          text: t("success_message", ((origin === "Companies" || origin === "SiteView") ? siteName : groupName), userEmail),
          icon: "success",
          timerProgressBar: true,
          timer: 1500,
        });
        if (origin === "Companies" || origin === "SiteView") {
          this.props.dispatch(singleSiteUserRemoveNotified())
        } else {
          this.props.dispatch(requestUserManagementRemoveNotified())
        };
      }
      if (error.message) {
        Alert({
          text: t(`errors.remove${devMode() ? "_dev" : ""}`, error.message),
          icon: "error",
          didClose: () => {
            // Reset error message
            if (origin === "Companies" || origin === "SiteView") {
              this.props.dispatch(singleSiteUserRemoveNotified())
            } else {
              this.props.dispatch(requestUserManagementRemoveNotified())
            };
          }
        });
      }
    }

    return (
      <Button
        disabled={disabled || loggedInUser.email === user.email}
        variant="danger"
        onClick={() => {
          Alert({
            text: t("confirm_message", ((origin === "Companies" || origin === "SiteView") ? siteName : groupName), userEmail),
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: t("confirm_button"),
            cancelButtonText: t("cancel_button")
          }).then(result => {
            if (result.value) {
              if (origin === "Companies" || origin === "SiteView") {
                this.props.dispatch(
                  singleSiteUserRemoveStart({
                    user_id,
                    sudo_site_id: this.props.sudoSiteId,
                  })
                )
              } else {
                this.props.dispatch(
                  requestUserManagementRemoveStart({
                    user_id,
                    group_id,
                    enterprise_id: enterprise.id
                  })
                )
              };
            }
          });
        }}>
        <Icon className="fas fa-times" />
      </Button>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    pathRoot: getPathRootFromRoute(state),
    group: getGroupFromRoute(state, props),
    enterprise: getEnterpriseFromRoute(state, props),
    users: state.users,
    loggedInUser: state.user,
  };
};
export default connect(mapStateToProps)(
  withT(Remove, "user_management.user_list.remove_user")
);
